
    import '/opt/buildhome/repo/packages/x/components/welcome/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["welcome-demo-basic","welcome-demo-variant","welcome-demo-background","welcome-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/welcome/index.zh-CN.md?type=demo')
};